import _ from 'lodash'

/**
 * (user/email={email}/profile, {email: "hello"}) => user/email=hello/profile
 */
export function formatString(str: string, params: any) {
    if (!params) {
        return str
    }
    _.each(params, (value, key) => {
        str = str.replace(`{${key}}`, value)
    })
    return str
}

/**
 * user/email={email}/profile => new Regex(user/email=*./profile)
 * only from axios mock
 */
export function formatStringToRegex(str: string) {
    const regStr = str.replace(/{.*?}/gm, '.*?').replace('/', '\\/')
    return new RegExp(regStr)
}
